import { accessTokenRefresh } from 'services/api/authService';
import { UserInfo } from 'types/UserInfo';
import { readStoredUser, writeStoredUser } from './authSession';

export const TOKENS_REFRESHED_EVENT = 'tottalo:tokens-refreshed';
export const SESSION_EXPIRED_EVENT = 'tottalo:session-expired';

let inflight: Promise<UserInfo | null> | null = null;

/**
 * Swaps the stored refresh token for a new token pair.
 *
 * The API rotates refresh tokens (the old one is revoked), so two refreshes
 * running at once would log the player out: the periodic refresh and a retry
 * after a 401 both come through here and share one request.
 */
export function refreshSessionTokens(): Promise<UserInfo | null> {
  if (inflight) return inflight;
  inflight = (async () => {
    const user = readStoredUser();
    if (!user) return null;
    const refreshed = await accessTokenRefresh(user);
    if (!refreshed) return null;
    const updated: UserInfo = {
      ...(readStoredUser() ?? user),
      access_token: refreshed.access,
      refresh_token: refreshed.refresh,
    };
    writeStoredUser(updated);
    window.dispatchEvent(
      new CustomEvent<UserInfo>(TOKENS_REFRESHED_EVENT, { detail: updated })
    );
    return updated;
  })().finally(() => {
    inflight = null;
  });
  return inflight;
}
